import React from 'react'
import { Typography } from "@mui/material"


export default function conditionNameColumn() {

	return {
		name: 'conditionName',
		label: 'Name',
		options: {
			customBodyRowRenderLite: value => <Typography>{value}</Typography>
		}
	}
}